var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsPoint1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#FFF5F0",
    stroke: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.108 16.184V17H10.5V16.184H12.342V10.322C12.342 10.146 12.348 9.968 12.36 9.788L10.83 11.102C10.778 11.146 10.726 11.174 10.674 11.186C10.622 11.194 10.574 11.194 10.53 11.186C10.486 11.178 10.444 11.162 10.404 11.138C10.368 11.114 10.34 11.088 10.32 11.06L9.984 10.598L12.546 8.384H13.416V16.184H15.108Z",
    fill: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsPoint1);
export default __webpack_public_path__ + "static/media/WHSPoint1.cf8b3802b52f43ee5aba74768e800b58.svg";
export { ForwardRef as ReactComponent };